import styled from "styled-components";
import { Slider as SlideBase } from "@mui/material";
import { SliderProps } from "@mui/material/Slider";
import { shade0, shade700 } from "../../../styles/tokens";

// TEXT

// STYLES
export const Slider = styled(SlideBase)`
  color: ${shade0};

  & .Mui-disabled {
  color: ${shade700};
  }

  & .MuiSlider-rail {
    background-color: ${shade700};
    opacity: 1;
  }

  & .MuiSlider-thumb,
  & .MuiSlider-track {
    border: none;
    background-color: ${({ disabled }) => (disabled ? shade700 : shade0)};
  }

  & .MuiSlider-thumb {
    width: 1rem;
    height: 1rem;
    box-shadow: none;

    &::before {
    display: none;
    }

&.Mui-focusVisible {
      /* MUI default focushalo often uses box-shadow, so we must disable it */
      box-shadow: none !important;

      /* THIS CREATES THE OUTER WHITE RING */
      outline: 2px solid ${shade0};

      /* THIS CREATES THE TRANSPARENT GAP between ring and thumb */
      outline-offset: 2px;
    }

    /* Keep the solid white color on hover and when active (dragging) */
    &:hover,
    &.Mui-active {
      background-color: ${shade0};
      box-shadow: none;
    }
  }

&.Mui-disabled {
    & .MuiSlider-thumb,
    & .MuiSlider-track {
      background-color: ${shade700};
    }
`;

// DATA

// TYPES
export type Props = SliderProps;

// CONSTANTS

// FUNCTIONS

// ASSETS
